import React from 'react';

import { Button, ButtonVariant } from '@/ui-library';
import { TestFlowStatus } from '@/utils/types/test-flow.types';

export const SummarizeText = ({
  data,
  onCancel,
  status,
}: {
  data?: { SummarizedText: string };
  onCancel: () => void;
  status: TestFlowStatus;
}) => {
  if (status === TestFlowStatus.WARNING) {
    return (
      <>
        <h2 className='text-NeutralDarkDarkest text-base not-italic font-black mb-5'>
          Your flow executed properly, but...
        </h2>
        <div className='flex flex-col gap-2 justify-center mb-8'>
          <p className='text-NeutralDarkLight mb-3'>
            No summary was generated. Please check your inputs or instructions and try again.
          </p>
          <div className='w-full flex gap-2 justify-center'>
            <Button variant={ButtonVariant.Secondary} onClick={onCancel}>
              Got it
            </Button>
          </div>
        </div>
      </>
    );
  }
  return (
    <>
      <h2 className='text-NeutralDarkDarkest text-base not-italic font-black mb-5'>We've summarized your text</h2>
      {data && (
        <div className='flex flex-col gap-2 justify-center mb-8'>
          <p className='text-NeutralDarkDark mb-3 text-sm'>Here's the summarized text based on your instructions:</p>
          <pre className='whitespace-pre-wrap text-sm bg-NeutralLightLight p-4 rounded-lg text-left'>
            <code>{data.SummarizedText}</code>
          </pre>
        </div>
      )}
      <div className='w-full flex gap-2 justify-center'>
        <Button variant={ButtonVariant.Primary} onClick={onCancel}>
          Close
        </Button>
      </div>
    </>
  );
};
